/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Account_HintInputs */

const cs_auth_signup_account_hint = /** @type {(inputs: Auth_Signup_Account_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kancelář a přihlašovací údaje majitele`)
};

const en_auth_signup_account_hint = /** @type {(inputs: Auth_Signup_Account_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Office and owner login details`)
};

/**
* | output |
* | --- |
* | "Office and owner login details" |
*
* @param {Auth_Signup_Account_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_account_hint = /** @type {((inputs?: Auth_Signup_Account_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Account_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signup_account_hint(inputs)
	return cs_auth_signup_account_hint(inputs)
});